module.exports = __webpack_public_path__ + "img/planner-feed-view-active.svg";